import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const BedroomsPerHouse = () => {
    const { chartData } = useHouseholdChartsDataContext();

    return (
        <SimpleBars
            title={'Quantidade de Dormitórios por Domicílio'}
            horizontal={true}
            subtitles={chartData?.bedroomsPerHouse?.map((item) => item.description)}
            values={chartData?.bedroomsPerHouse?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
